import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  active: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ active, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            active === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-200 text-foreground-300 hover:text-foreground-100 hover:bg-background-300/50'
          }`}
        >
          <i className={`${cat.icon} text-sm`} />
          {cat.name}
        </button>
      ))}
      <Link
        to="/category/all"
        className="flex items-center gap-1 px-3 py-2 text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap ml-auto"
      >
        查看全部
        <i className="ri-arrow-right-line text-sm" />
      </Link>
    </div>
  );
}